import "../../assets/css/header.css";
import "../../assets/css/material-dashboard.css";
import coat from "../../assets/img/coat.png";
import imm from "../../assets/img/immigration.png";
import { Link } from "react-router-dom";

function App() {
  return (
    <>
      <div className="logoNavbar fixed-top">
        <div className="navbarContainer">
          <div className="row">
            <div className="col-md-1 col-sm-1 col-xs-1 vertical-align text-left hidden-xs">
              <img src={coat} alt="Logo" />
            </div>
            <div className="col-md-10 col-sm-10 col-xs-12 vertical-align text-center">
              <h5 className="m-b-1 header-title" style={{ color: "white" }}>
                <b>ETD-ADMINISTRATION</b>
              </h5>
              <nav
                className="barNav barNav-main barNav-default"
                role="navigation"
                style={{ opacity: 1 }}
              >
                <div className="barNavContainer col-sm-12">
                  <div className="barNav-header">
                    <button
                      type="button"
                      className="barNav-toggle"
                      data-toggle="collapse"
                      data-target=".barNav-1"
                    >
                      <span className="sr-only">Toggle navigation</span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                  </div>
                  <div
                    className="collapse barNav-collapse barNav-1"
                    style={{ marginTop: "0px" }}
                  >
                    <ul className="nav barNav-nav">
                      <li>
                        <Link to="/ETD">Home</Link>
                      </li>
                      <li>
                        <Link to="/etd">Emergence Travel Document</Link>
                      </li>
                      <li>
                        <Link to="/ETD">
                          <small>V1.2.04</small>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
            <div className="col-md-1 col-sm-1 col-xs-1 vertical-align hidden-xs">
              <img src={imm} alt="Logo" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
